import React, { useEffect, useState } from 'react';
import './sidebar.css';
import { MdDashboard } from "react-icons/md";
import { FaCreditCard } from "react-icons/fa";
import { GiTakeMyMoney } from "react-icons/gi";
import { HiOutlineCurrencyRupee } from "react-icons/hi";
import ListSidebar from '../../Components/ListSidebar';
import { IoDocuments } from "react-icons/io5";
import { FaMobileScreenButton ,FaInternetExplorer } from "react-icons/fa6";
import { MdPayments ,MdOutlineMiscellaneousServices} from "react-icons/md";
import { CgProfile } from "react-icons/cg";
import { Link } from 'react-router-dom';
import { SiTestcafe } from "react-icons/si";
import { BsBank2 } from "react-icons/bs";
import { LiaTachometerAltSolid } from "react-icons/lia";
import AOS from 'aos';
import 'aos/dist/aos.css';
import NetworkBackground from '../../Pages/LoginPages/NetworkBackground';
import { FileText, Receipt } from "lucide-react";

export default function Sidebar() {
  const [expandedMenus, setExpandedMenus] = useState({});

  function handleCloseTop() {
    const sidebarMain = document.querySelector('.siderbar_main');
    const mainComponent = document.querySelector('#main_component');
    const width = window.innerWidth;
    
    if (width <= 1024) {
      sidebarMain.classList.toggle('sidemar_main_3');
    } else {
      sidebarMain.classList.toggle('sidemar_main_2');
      mainComponent.classList.toggle('main_component2');
    }
  }

  function toggleSubmenu(menuKey) {
    setExpandedMenus(prev => ({
      ...prev,
      [menuKey]: !prev[menuKey]
    }));
  }

  useEffect(() => {
    function handleClickOutside(event) {
      const sidebarMain = document.querySelector('.siderbar_main');
      const width = window.innerWidth;

      if (width <= 1024 && sidebarMain && !sidebarMain.contains(event.target)) {
        // If clicked outside sidebar, and in phone view, close it
        sidebarMain.classList.remove('sidemar_main_3');
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    // Clean up event when component unmounts
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    AOS.init({ duration: 1500, once: true });
  }, []);

  return (
    <>
      <div className="items-center md:mt-0 mt-3 bg-gradient-to-br from-blue-800 to-blue-900 flex flex-col max-h-auto h-dvh max-w-max overflow-y-auto w-2/4 p-1 pb-20  rounded siderbar_main" >
        <NetworkBackground />
        <div className='box-border relative flex flex-col max-w-max w-32 justify-center items-center'>
          <img
className=" max-150"
src={
process.env.PUBLIC_URL + "/media/logo/idspay_horizontal_white.png"
}
alt="logo"
          
          />
          <div onClick={handleCloseTop} className="absolute close_top">
            <div
              className="flex cursor-pointer items-center justify-center text-3xl text-white caret-transparent"
            >
              <div
                className="group relative inline-flex w-24 items-center justify-center overflow-hidden rounded-full border-2 font-medium shadow-md h-5"
              >
                <span
                  className="ease absolute z-10 flex h-full w-full translate-y-full items-center justify-center rounded-full bg-[#d1b98a] text-white duration-300 group-hover:translate-y-0"
                ></span>
                <div
                  className="absolute z-50 flex h-full w-full items-center justify-center text-[#f6f2f2] group-hover:text-white"
                >
                  <svg
                  lazy="loading"
                    height="20px"
                    width="20px"
                    viewBox="0 0 72 72"
                    xmlns="http://www.w3.org/2000/svg"
                  
                  >
                    <path
                      fill="white"
                      d="M 19 15 C 17.977 15 16.951875 15.390875 16.171875 16.171875 C 14.609875 17.733875 14.609875 20.266125 16.171875 21.828125 L 30.34375 36 L 16.171875 50.171875 C 14.609875 51.733875 14.609875 54.266125 16.171875 55.828125 C 16.951875 56.608125 17.977 57 19 57 C 20.023 57 21.048125 56.609125 21.828125 55.828125 L 36 41.65625 L 50.171875 55.828125 C 51.731875 57.390125 54.267125 57.390125 55.828125 55.828125 C 57.391125 54.265125 57.391125 51.734875 55.828125 50.171875 L 41.65625 36 L 55.828125 21.828125 C 57.390125 20.266125 57.390125 17.733875 55.828125 16.171875 C 54.268125 14.610875 51.731875 14.609875 50.171875 16.171875 L 36 30.34375 L 21.828125 16.171875 C 21.048125 15.391875 20.023 15 19 15 z"
                    ></path>
                  </svg>
                </div>
              </div>
            </div>

          </div>
        </div>
        <hr />
        <ul className="list-unstyled mt-1 items-center flex flex-col gap-0.5">
          
          <ListSidebar link="/Dashboard" buttonText="Dashboard" icon={<MdDashboard />} />
          
          <li className="my-1 mx-2" >
            <button 
              className='_btn_ btn_with_submenu btn_submenu_2'
              onClick={() => toggleSubmenu('payouts')}
            >
              <div className="overflow-hidden text flex justify-left gap-2" style={{ height: expandedMenus.payouts ? 'auto' : '36px' }}>
                <span className='relative top-1'>
                  <HiOutlineCurrencyRupee />
                </span>
                <div className='flex flex-col m-0 p-0'>
                  <span className='flex items-start font-semibold text-sm'>
                    Payouts 
                    <svg 
                      lazy="loading" 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="25" 
                      height="25" 
                      fill="currentColor" 
                      className={`bi bi-arrow-down-short transition-transform duration-300 ${expandedMenus.payouts ? 'rotate-180' : ''}`} 
                      viewBox="0 0 16 16"
                    >
                      <path fillRule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4" />
                    </svg>
                    <span className='text-red-600 animate-scrollUp text-xs mt-1'>New</span>
                  </span>
                  {expandedMenus.payouts && (
                    <ul className='list-circle listInside mt-2'>
                    <Link to="/payout/single"><li className='align-left py-1 my-1 li_hover'>Single Payout</li></Link>
                    <Link to="/payout/bulk"><li className='align-left py-1 my-1 li_hover'>Bulk Payout</li></Link>
                    <Link to="/payout/manage-beneficiary"><li className='align-left py-1 my-1 li_hover'>Manage Beneficiary</li></Link>
                    <Link to="/payout/report"><li className='align-left py-1 my-1 li_hover'>Payout Report</li></Link>
                  </ul>
                  )}
                </div>
              </div>
            </button>
          </li>

          <li className="my-1 mx-2" >
            <button 
              className='_btn_ btn_with_submenu btn_submenu_2'
              onClick={() => toggleSubmenu('collect')}
            >
              <div className="overflow-hidden text flex justify-left gap-2" style={{ height: expandedMenus.collect ? 'auto' : '36px' }}>
                <span className='relative top-1'>
                  <GiTakeMyMoney />
                </span>
                <div className='flex flex-col m-0 p-0'>
                  <span className='flex items-center font-semibold text-sm'>
                    Collect
                    <svg 
                      lazy="loading" 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="25" 
                      height="25" 
                      fill="currentColor" 
                      className={`bi bi-arrow-down-short transition-transform duration-300 ${expandedMenus.collect ? 'rotate-180' : ''}`} 
                      viewBox="0 0 16 16"
                    >
                      <path fillRule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4" />
                    </svg>
                  </span>
                  {expandedMenus.collect && (
                    <ul className='list-circle listInside mt-2 relative left_15'>
                      <Link to="/VanCollectionReport"><li className='align-left py-1 my-1 li_hover'>Van Collection Report</li></Link>
                      <Link to="#"><li className='align-left py-1 my-1 li_hover'>UPI Collection report</li></Link>
                    </ul>
                  )}
                </div>
              </div>
            </button>
          </li>

          <li className="my-1 mx-2" >
            <button 
              className='_btn_ btn_with_submenu btn_submenu_2'
              onClick={() => toggleSubmenu('cards')}
            >
              <div className="overflow-hidden text flex justify-left gap-2" style={{ height: expandedMenus.cards ? 'auto' : '36px' }}>
                <span className='relative top-1'>
                  <FaCreditCard />
                </span>
                <div className='flex flex-col m-0 p-0'>
                  <span className='flex items-center font-semibold text-sm'>
                    Cards
                    <svg 
                      lazy="loading" 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="25" 
                      height="25" 
                      fill="currentColor" 
                      className={`bi bi-arrow-down-short transition-transform duration-300 ${expandedMenus.cards ? 'rotate-180' : ''}`} 
                      viewBox="0 0 16 16"
                    >
                      <path fillRule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4" />
                    </svg>
                  </span>
                  {expandedMenus.cards && (
                    <ul className='list-circle listInside mt-2'>
                     <Link to="/PrepaidCard"> <li className='align-left py-1 my-1 li_hover'>Prepaid Card</li></Link>
                      <Link to="/ExpenseCard"><li className='align-left py-1 my-1 li_hover'>Expense Card</li></Link>
                    </ul>
                  )}
                </div>
              </div>
            </button>
          </li>

          <li className="my-1 mx-2" >
            <button 
              className='_btn_ btn_with_submenu btn_submenu_3'
              onClick={() => toggleSubmenu('apiServices')}
            >
              <div className="overflow-hidden text flex justify-left gap-2" style={{ height: expandedMenus.apiServices ? 'auto' : '36px' }}>
                <span className='relative top-1'>
                  <MdOutlineMiscellaneousServices />
                </span>
                <div className='flex flex-col m-0 p-0'>
                  <span className='flex items-center font-semibold text-sm'>
                    API Services
                    <svg 
                      lazy="loading" 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="25" 
                      height="25" 
                      fill="currentColor" 
                      className={`bi bi-arrow-down-short transition-transform duration-300 ${expandedMenus.apiServices ? 'rotate-180' : ''}`} 
                      viewBox="0 0 16 16"
                    >
                      <path fillRule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4" />
                    </svg>
                  </span>
                  {expandedMenus.apiServices && (
                    <ul className='list-circle listInside mt-2'>
                      <Link to="/ServicePage"><li className='align-left py-1 my-1 li_hover'>Developers API</li></Link>
                      <Link to="/ApiIntegrationGuide"><li className='align-left py-1 my-1 li_hover'>Api Integration Guide</li></Link>
                      {/* <Link to="/CommissionCharges"><li className='align-left py-1 my-1 li_hover'>Commission & Charges</li></Link> */}
                    </ul>
                  )}
                </div>
              </div>
            </button>
          </li>


     <li className="my-1 mx-2" >
            <button 
              className='_btn_ btn_with_submenu btn_submenu_3'
              onClick={() => toggleSubmenu('autoDebit')}
            >
              <div className="overflow-hidden text flex justify-left gap-2" style={{ height: expandedMenus.autoDebit ? 'auto' : '36px' }}>
                <span className='relative top-1'>
                 <BsBank2 />
                </span>
                <div className='flex flex-col m-0 p-0'>
                  <span className='flex items-center font-semibold text-sm'>
                    Auto Debit
                    <svg 
                      lazy="loading" 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="25" 
                      height="25" 
                      fill="currentColor" 
                      className={`bi bi-arrow-down-short transition-transform duration-300 ${expandedMenus.autoDebit ? 'rotate-180' : ''}`} 
                      viewBox="0 0 16 16"
                    >
                      <path fillRule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4" />
                    </svg>
                  </span>
                  {expandedMenus.autoDebit && (
                    <ul className='list-circle listInside mt-2'>
                       <Link to="/CreateMandate"><li className='align-left py-1 my-1 li_hover'>Create Mandate</li></Link>
                      <Link to="/MandateReport"><li className='align-left py-1 my-1 li_hover'>Mandate Report</li></Link>
                     
                    </ul>
                  )}
                </div>
              </div>
            </button>
          </li>



   

          <li className="my-1 mx-2" >
            <button className='_btn_ btn_with_submenu btn_submenu_1'>
              <div className="overflow-hidden h-9 text flex justify-left gap-2">
                <span className='relative top-1'>
                 <FaMobileScreenButton />
                </span>
                <div className='flex flex-col m-0 p-0'>
                <Link to="/CreateMobileDeviceLock"><span className='flex items-center font-semibold text-sm'>
                  Lock Mobile
                   </span>
                 </Link>
                </div>
                </div>
            </button>
          </li>




     <li className="my-1 mx-2" >
            <button 
              className='_btn_ btn_with_submenu btn_submenu_3'
              onClick={() => toggleSubmenu('BulkService')}
            >
              <div className="overflow-hidden text flex justify-left gap-2" style={{ height: expandedMenus.BulkService ? 'auto' : '36px' }}>
                <span className='relative top-1'>
                 <BsBank2 />
                </span>
                <div className='flex flex-col m-0 p-0'>
                  <span className='flex items-center font-semibold text-sm'>
                    Bulk Service
                    <svg 
                      lazy="loading" 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="25" 
                      height="25" 
                      fill="currentColor" 
                      className={`bi bi-arrow-down-short transition-transform duration-300 ${expandedMenus.BulkService ? 'rotate-180' : ''}`} 
                      viewBox="0 0 16 16"
                    >
                      <path fillRule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4" />
                    </svg>
                  </span>
                  {expandedMenus.BulkService && (
                    <ul className='list-circle listInside mt-2'>
                       <Link to="/BulkUpload"><li className='align-left py-1 my-1 li_hover'>Din To Contact</li></Link>


                      <Link to="/GstBulkUpload">
                        <li className="align-left py-1 my-1 li_hover">
                          Gst Bulk Upload
                        </li>
                      </Link>

                      <Link to="/BulkRcToMobile">
                        <li className="align-left py-1 my-1 li_hover">
                          RC To Mobile
                        </li>
                      </Link>

                      <Link to="/BulkPanToContact">
                        <li className="align-left py-1 my-1 li_hover">
                         PAN To Contact
                        </li>
                      </Link>

                      {/* <Link to="/BulkDownload"><li className='align-left py-1 my-1 li_hover'>Report</li></Link>
                      <Link to="/GstToContactReport">
                        <li className="align-left py-1 my-1 li_hover">
                         gst Report
                        </li>
                      </Link> */}

                         <Link to="/BulkReportAll">
                        <li className="align-left py-1 my-1 li_hover">
                          Report
                        </li>
                      </Link>
                     
                    </ul>
                  )}
                </div>
              </div>
            </button>
          </li>

          <li className='my-1 mx-2' >
            <button 
              className='_btn_ btn_with_submenu btn_submenu_7'
              onClick={() => toggleSubmenu('creditScore')}
            >
              <div className='overflow-hidden text flex justify-left gap-1' style={{ height: expandedMenus.creditScore ? 'auto' : '36px' }}>
                <span className='relative top-0'>
                    <LiaTachometerAltSolid size={24} />
                </span>
                <div className='flex flex-col m-0 p-0'>
                  <span className='flex items-center font-semibold text-sm'>
                    Credit Score
                    <svg 
                      lazy="loading" 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="25" 
                      height="25" 
                      fill="currentColor" 
                      className={`bi bi-arrow-down-short transition-transform duration-300 ${expandedMenus.creditScore ? 'rotate-180' : ''}`} 
                      viewBox="0 0 16 16"
                    >
                      <path fillRule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4" />
                    </svg>
                    <span className='text-red-600 animate-scrollUp text-xs mt-1'>New</span>
                  </span>
                  {expandedMenus.creditScore && (
                    <ul className='list-circle listInside mt-2'>
                      {/* <li className='align-left py-1 my-1 li_hover'><Link to="/EquifaxCrScore">Eqifax Score</Link></li> */}
                     <Link to="/CheckScore"> <li className='align-left py-1 my-1 li_hover'>Check Score Only</li></Link>
                      {/* <Link to="/CheckScorePrefill"><li className='align-left py-1 my-1 li_hover'>Check Score Prefill</li></Link> */}
                        <Link to="/credit-report/experian"><li className='align-left py-1 my-1 li_hover'>Experian Credit Report</li></Link>
                     <Link to="/ExperianScore2"><li className='align-left py-1 my-1 li_hover'>Experian (V2) Report</li></Link>
                     <Link to="/ExperianScore3"><li className='align-left py-1 my-1 li_hover'>Experian (V3) Report</li></Link>
                       <Link to="/CrifCreditScore"><li className='align-left py-1 my-1 li_hover'>Crif Credit Report</li></Link>
                       <Link to="/CrifCreditScore2"><li className='align-left py-1 my-1 li_hover'>Crif (V2) Credit Report</li></Link>
                       <Link to="/CrifCreditScore4"><li className='align-left py-1 my-1 li_hover'>Crif (V4) Credit Report</li></Link>
                       <Link to="/CrifScoreCheck"><li className='align-left py-1 my-1 li_hover'>Crif Score Check</li></Link>
                      <Link to="/credit-report/equifax-v2"><li className='align-left py-1 my-1 li_hover'>Equifax (V2)</li></Link>
                      {/* <Link to="/credit-report/equifax-v2"><li className='align-left py-1 my-1 li_hover'>Equifax (V2)</li></Link> */}
                      
                   <Link to="/EquifaxCreditReportDashboard"><li className='align-left py-1 my-1 li_hover'>Equifax Credit Report</li></Link>

                      <Link to="/EquifaxPdfUrl"><li className='align-left py-1 my-1 li_hover'>Equifax PDF Report</li></Link>
                       <Link to="/CrifPdfUrl"><li className='align-left py-1 my-1 li_hover'>Crif PDF Report</li></Link>
                       <Link to="/transunion-pdf"><li className='align-left py-1 my-1 li_hover'>TransUnion PDF Report</li></Link>
                      <Link to="/experian-pdf"><li className='align-left py-1 my-1 li_hover'>Experian PDF Report</li></Link>
                      <Link to="/experian-v2-pdf"><li className='align-left py-1 my-1 li_hover'>Experian V2 PDF Report</li></Link>


                      {/* <li className='align-left py-1 my-1 li_hover'><Link to="/HighmarkCrScore">Highmark</Link></li> */}
                      {/* <li className='align-left py-1 my-1 li_hover'><Link to="/Crif_EquifaxReport">Crif & Equifax Report</Link></li> */}
                       {/* <Link to="/credit-report/transunion"><li className='align-left py-1 my-1 li_hover'>TransUnion Report (V1)</li></Link> */}
                       <Link to="/credit-report/transunion2"><li className='align-left py-1 my-1 li_hover'>TransUnion Report (V2)</li></Link>
                       <Link to="/credit-report/transunion3"><li className='align-left py-1 my-1 li_hover'>TransUnion Report (V3)</li></Link>
                       <Link to="/transunion-hybrid"><li className='align-left py-1 my-1 li_hover'>TransUnion Hybrid</li></Link>
                       <Link to="/transunion-hybrid-pdf"><li className='align-left py-1 my-1 li_hover'>TransUnion Hybrid PDF</li></Link>
                      <Link to="/CreditScoreReport"><li className='align-left py-1 my-1 li_hover'>Report</li></Link>
                      {/* <Link to="/CreditScorePDF"><li className='align-left py-1 my-1 li_hover'>CreditScorePDF</li></Link> */}
                    </ul>
                  )}
                </div>
              </div>
            </button>
          </li>







          <li className="my-1 mx-2" >
            <button 
              className='_btn_ btn_with_submenu btn_submenu_3'
              onClick={() => toggleSubmenu('statementAnalyzer')}
            >
              <div className="overflow-hidden text flex justify-left gap-2" style={{ height: expandedMenus.statementAnalyzer ? 'auto' : '36px' }}>
                <span className='relative top-1'>
                  <IoDocuments />
                </span>
                <div className='flex flex-col m-0 p-0'>
                  <span className='flex items-center font-bold text-sm'>
                    Statement Analyzer
                    <svg 
                      lazy="loading" 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="25" 
                      height="25" 
                      fill="currentColor" 
                      className={`bi bi-arrow-down-short transition-transform duration-300 ${expandedMenus.statementAnalyzer ? 'rotate-180' : ''}`} 
                      viewBox="0 0 16 16"
                    >
                      <path fillRule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4" />
                    </svg>
                  </span>
                  {expandedMenus.statementAnalyzer && (
                    <ul className='list-circle listInside mt-2'>
                      <Link to="/StatementAnalyzer"><li className='align-left py-1 my-1 li_hover'>Statement Analyzer
                       <span className='text-red-600 animate-scrollUp text-xs mt-1 ms-1'>New</span>
                      </li></Link>
                      <Link to="/StatementReport"><li className='align-left py-1 my-1 li_hover'>Statement Report
                       <span className='text-red-600 animate-scrollUp text-xs mt-1 ms-2'>New</span></li></Link>
                    </ul>
                  )}
                </div>
              </div>
            </button>
          </li>





          <li className="my-1 mx-2" >
            <button 
              className='_btn_ btn_with_submenu btn_submenu_2'
              onClick={() => toggleSubmenu('recharge')}
            >
              <div className="overflow-hidden text flex justify-left gap-2" style={{ height: expandedMenus.recharge ? 'auto' : '36px' }}>
                <span className='relative top-1'>
                  <MdPayments />
                </span>
                <div className='flex flex-col m-0 p-0'>
                  <span className='flex items-center font-bold text-sm'>
                    Recharge & BBPS
                    <svg 
                      lazy="loading" 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="25" 
                      height="25" 
                      fill="currentColor" 
                      className={`bi bi-arrow-down-short transition-transform duration-300 ${expandedMenus.recharge ? 'rotate-180' : ''}`} 
                      viewBox="0 0 16 16"
                    >
                      <path fillRule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4" />
                    </svg>
                  </span>
                  {expandedMenus.recharge && (
                    <ul className='list-circle listInside mt-2'>
                     <Link to="/RechargeAndBBPSReport"> <li className='align-left py-1 my-1 li_hover'>
                        Recharge & BBPS Report
                      </li></Link>
                    </ul>
                  )}
                </div>
              </div>
            </button>
          </li>


          <li className="my-1 mx-2" >
            <button className='_btn_ btn_with_submenu btn_submenu_1'>
              <div className="overflow-hidden h-9 text flex justify-left gap-2">
                <span className='relative top-1'>
                 <BsBank2 />
                </span>
                <div className='flex flex-col m-0 p-0'>
                <Link to="/mandate"><span className='flex items-center font-semibold text-sm'>
                    Auto Debit V2
                   </span>
                 </Link>
                </div>
                </div>
            </button>
          </li>

          <li className="my-1 mx-2" >
            <button className='_btn_ btn_with_submenu btn_submenu_1'>
              <div className="overflow-hidden h-9 text flex justify-left gap-2">
                <span className='relative top-1'>
                 <FaInternetExplorer />
                </span>
                <div className='flex flex-col m-0 p-0'>
                <Link to="/WhiteListIP"><span className='flex items-center font-semibold text-sm'>
                    IP Whitelist
                   </span>
                 </Link>
                </div>
                </div>
            </button>
          </li>

          <li className="my-1 mx-2" >
            <button className='_btn_ btn_with_submenu '>
              <div className="overflow-hidden h-9 text flex justify-left gap-2">
                <span className='relative top-1'>
                <SiTestcafe />
                </span>
                <div className='flex flex-col m-0 p-0'>
                <Link to="/TestMaster"><span className='flex items-center font-semibold text-sm'>
                    Test API
                    <span className='text-red-600 animate-scrollUp text-xs mt-1'>New</span>
                    </span>
                    </Link>
                </div>
              </div>
            </button>
          </li>

          <li className="my-1 mx-2" >
            <button 
              className='_btn_ btn_with_submenu btn_submenu_5'
              onClick={() => toggleSubmenu('myAccount')}
            >
              <div className="overflow-hidden text flex justify-left gap-2" style={{ height: expandedMenus.myAccount ? 'auto' : '36px' }}>
                <span className='relative top-1'>
                  <CgProfile />
                </span>
                <div className='flex flex-col m-0 p-0'>
                  <span className='flex items-center font-semibold text-sm'>
                    My Account
                    <svg 
                      lazy="loading" 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="25" 
                      height="25" 
                      fill="currentColor" 
                      className={`bi bi-arrow-down-short transition-transform duration-300 ${expandedMenus.myAccount ? 'rotate-180' : ''}`} 
                      viewBox="0 0 16 16"
                    >
                      <path fillRule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4" />
                    </svg>
                  </span>
                  {expandedMenus.myAccount && (
                    <ul className='list-circle listInside mt-2 mb-3'>
                    <Link to="/BusinessWalletStructure"><li className='align-left py-1 my-1 li_hover'>Wallet Statement</li></Link>
                      <Link to="/WhitelistYourBankAc"><li className='align-left py-1 my-1 li_hover'>Whitelist Bank A/c</li></Link>
                      {/* <Link to="/AepsSettlement"><li className='align-left py-1 my-1 li_hover'>AePS Settlement Report</li></Link> */}
                      {/* <Link to="/BillingInvoice"><li className='align-left py-1 my-1 li_hover'>Billing & Invoices</li></Link> */}
                      <Link to="/ProfileApiUser"><li className='align-left py-1 my-1 li_hover'>My Profile</li></Link>
                      <Link to="/LowBalanceAlert"><li className='align-left py-1 my-1 li_hover'>Low Balance Alert</li></Link>
                      <Link to="/HelpDesk"><li className='align-left py-1 my-1 li_hover mb-2'>Help Desk</li></Link>
                    </ul>
                  )}
                </div>
              </div>
            </button>
          </li>
          
        </ul>
      </div>
    </>
  )
}